import type { GetProjects } from '@/server/api/rest/project/project-repository.ssr';
import type { FC } from 'react';
import { ProjectCard } from './project-card';

type ProjectGridProps = {
  readonly projects: GetProjects;
};

export const ProjectGrid: FC<ProjectGridProps> = ({ projects }) => {
  return (
    <div className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
      {projects.map((project) => {
        if (!project.client) {
          return <div key={`${project.id}`}>Project Client not found</div>;
        }

        return (
          <ProjectCard
            key={`${project.id}`}
            project={project}
            images={project.images}
            slug={project.slug}
          />
        );
      })}
    </div>
  );
};
